import React from 'react';
import '../styles/footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__container">
        {/* Coffee Icon */}
        <div className="site-footer__icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 5V12" stroke="#00D5BE" strokeWidth="5" strokeLinecap="round"/>
            <path d="M29 5V12" stroke="#00D5BE" strokeWidth="5" strokeLinecap="round"/>
            <path d="M40 5V12" stroke="#00D5BE" strokeWidth="5" strokeLinecap="round"/>
            <path d="M8 20H48V50C48 54.42 44.42 58 40 58H16C11.58 58 8 54.42 8 50V20Z" stroke="#00D5BE" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M48 28H52C55.31 28 58 30.69 58 34C58 37.31 55.31 40 52 40H48" stroke="#00D5BE" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        {/* Heading */}
        <h2 className="site-footer__heading">Love What We Do?</h2>
        
        {/* Subheading */}
        <p className="site-footer__subheading">Support us and keep the dance community thriving!</p>
        
        {/* Buy Me a Coffee Button */}
        <a 
          href="https://www.buymeacoffee.com/myeventsbridge" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="site-footer__coffee-btn"
        >
          <svg viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 18.35L8.55 17.03C3.4 12.36 0 9.28 0 5.5C0 2.42 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.09C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.42 20 5.5C20 9.28 16.6 12.36 11.45 17.04L10 18.35Z"/>
          </svg>
          Buy Me a Coffee
        </a>
        
        {/* Bottom Section */}
        <div className="site-footer__bottom">
          <div className="site-footer__bottom-row">
            <div className="site-footer__legal">
              <p className="site-footer__copyright">© {currentYear} My Events Bridge</p>
              <div className="site-footer__links">
                <a href="/privacy-policy.html" className="site-footer__link">Privacy Policy</a>
                <span className="site-footer__divider">|</span>
                <a href="/terms-of-use.html" className="site-footer__link">Terms of Use</a>
              </div>
            </div>
            <a href="/contact.html" className="site-footer__contact">
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1.33" y="2.67" width="13.33" height="10.67" rx="2" stroke="#00D5BE" strokeWidth="1.33"/>
                <path d="M1.33 4.67L8 9.33L14.67 4.67" stroke="#00D5BE" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Contact Us
            </a>
          </div>
          <p className="site-footer__tagline">Connecting dancers across the San Francisco Bay Area</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

